import type { WeaponId } from '../weaponData';

/**
 * Sid Marlowe, the fence (his portrait: public/art/portraits/sid.webp). He isn't in the back room's
 * showcase (the weapon is the hero, docs/WEAPONS.md §6); his voice is: one line of his under the blurb
 * on the panel.
 */
export const SID_NAME = 'Sid Marlowe';

/**
 * What Sid says in the back room (spoken lines: his voice, his slang), shown small under the blurb. The
 * panel says the plain facts; these are colour. Original lines (docs/research/GTA-LONDON-CHINATOWN.md §5).
 */
export const SID_LINES = {
  weapon: {
    cosh: 'Lead shot in a leather sock. Sends a man to sleep, not to the churchyard.',
    bat: 'Good English willow, that. Somebody’s Sunday eleven is a man short.',
    crowbar: 'Every builder’s got one. So has every burglar. Car doors give up quick.',
    knife: 'Quick and quiet. Don’t wave it about, son. That’s a stretch inside, that is.',
    revolver: 'Ex-service. Numbers filed off. Six in the wheel, and the whole nick hears every one.',
    sawnoff: 'Both barrels, cut down short. Close up, nothing argues with it.',
  } as Partial<Record<WeaponId, string>>,
  sold: ['Pleasure doing business.', 'You didn’t get it from me.', 'Keep it out of sight, eh?', 'Mind how you go.', 'Under the coat, son. Not down the trousers, I’ve seen how that ends.', 'If anybody asks, you found it. In a canal.'],
  rounds: ['There’s your rounds. Don’t go spraying them about.', 'A box, wrapped in yesterday’s racing paper. Go careful.', 'Count them. I did. Don’t make me count the ones you’ve used.'],
  short: ['Come back when your pockets are heavier.', 'That’s not enough, son. I’m not running a soup kitchen.', 'Short. I don’t do tick, and I don’t do charity.'],
  got: ['You’ve already got one of them.', 'One each, son. I’m not a wholesaler.'],
  noGun: ['Rounds are no use without the shooter, are they?', 'What are you going to do, throw them?'],
  full: ['Your pockets are full, son. Use some first.', 'You rattle when you walk as it is.'],
};
